exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_OrgAssetContainer_2nZ786-lE3TzxTbOB6a0im {\n  display: flex;\n  flex-direction: column;\n  padding-left: 40px;\n  padding-right: 40px;\n}\n\n.IA_OrgAssetItemsContainer_3pU536Q_OwnwJ536hLpsnf {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n}\n\n.IA_OrgAssetErrorMessage_2_ORZIu4hkuCt6z8mExBgW {\n  padding-top: 15px;\n  font-size: 16px;\n}", ""]);

// Exports
exports.locals = {
	"IA_OrgAssetContainer": "IA_OrgAssetContainer_2nZ786-lE3TzxTbOB6a0im",
	"IA_OrgAssetItemsContainer": "IA_OrgAssetItemsContainer_3pU536Q_OwnwJ536hLpsnf",
	"IA_OrgAssetErrorMessage": "IA_OrgAssetErrorMessage_2_ORZIu4hkuCt6z8mExBgW"
};